// import { cashierClientType, cashierChannelType, cashierPayType } from '@/dataControl';
import * as datalist from '@/dataControl';
/**
 * 毫秒转换成日期
 *
 */
function millisecondFormat(time, flag) {
  if (!time) return '无';
  if (typeof (time * 1) === 'number' && time.toString().length === 13) {
    var oDate = new Date(time * 1);
    var year = oDate.getFullYear();
    var month = (oDate.getMonth() + 1) >= 10 ? oDate.getMonth() + 1 : '0' + (oDate.getMonth() + 1);
    var date = oDate.getDate() >= 10 ? oDate.getDate() : '0' + oDate.getDate();
    var hours = oDate.getHours() >= 10 ? oDate.getHours() : '0' + oDate.getHours();
    var minutes = oDate.getMinutes() >= 10 ? oDate.getMinutes() : '0' + oDate.getMinutes();
    var seconds = oDate.getSeconds() >= 10 ? oDate.getSeconds() : '0' + oDate.getSeconds();
    if (flag === 'ms') {
      return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
    } else if (flag === 'ym') {
      return `${year}-${month}`;
    } else {
      return `${year}-${month}-${date}`;
    }
  } else if (time instanceof Date) {
    var y = time.getFullYear();
    var M = (time.getMonth() + 1) >= 10 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1);
    var d = time.getDate() >= 10 ? time.getDate() : '0' + time.getDate();
    var h = time.getHours() >= 10 ? time.getHours() : '0' + time.getHours();
    var m = time.getMinutes() >= 10 ? time.getMinutes() : '0' + time.getMinutes();
    var s = time.getSeconds() >= 10 ? time.getSeconds() : '0' + time.getSeconds();
    if (flag === 'ms') {
      return `${y}-${M}-${d} ${h}:${m}:${s}`;
    } else if (flag === 'ym') {
      return `${y}-${M}`;
    } else {
      return `${y}-${M}-${d}`;
    }
  } else if (!time&&time.indexOf('-') > -1 && time.indexOf(':') > -1) {
    return time;
  } else {
    return '无';
  }
};

// 百分比
function toPercent(v) {
  if (!v) return '0.00%';
  return (Math.round(v * 10000) / 100).toFixed(2) + '%';
}

const digitsRE = /(\d{3})(?=\d)/g;
function currency(value, currency, decimals) {
  value = parseFloat(value);
  if (!isFinite(value) || (!value && value !== 0)) return '';
  currency = currency != null ? currency : '￥';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
};

// 人民币
function moneySkin(v, flag) {
  if (v) {
    if (flag === 'rmb') {
      return currency(v, '¥ ');
    } else if (flag === 'do') {
      return currency(v, '', 3);
    } else if (flag === 'dollar') {
      return currency(v, '$ ', 3);
    } else {
      return currency(v, '');
    }
  } else {
    if (flag === 'rmb') {
      return '¥ 0.00';
    } else if (flag === 'do') {
      return '0.000';
    } else if (flag === 'dollar') {
      return '$ 0.000';
    } else {
      return '0.00';
    }
  }
}

function numberToText(val) {
  // 空转0
  if (!val) {
    return 0;
  } else {
    return val;
  }
};

// 银行卡截取
function bankDot(v) {
  if (!v) return '无';
  return v.replace(/^(\d{4})\d+(\d{4})$/, '$1****$2');
}

// 是否审核
function auditFlagfiter(val) {
  let obj = {
    1: '免审',
    2: '非免审'
  };
  return obj[val];
}
// 积分出入方向   1收入 2支出
function inOrOutfiter(val) {
  let obj = {
    1: '收入',
    2: '支出'
  };
  return obj[val];
}
// 运营模式
function autoOperationFlagfiter(val) {
  let obj = {
    1: '自运营',
    2: '代运营'
  };
  return obj[val];
}
// 确认收货范围
function receivingTimePlatToText(val) {
  let obj = {
    1: '全平台'
  };
  return obj[val];
}
// 是否收费1：免费 2：收费
function feeFlagToText(val) {
  let obj = {
    1: '免费',
    2: '收费'
  };
  return obj[val];
}
// 信息来源
function carSourceToText(val) {
  let obj = {
    1: '云ERP ',
    2: '云管理平台'
  };
  return obj[val];
}
function noneToText(val) {
  // 空字段对应无
  let obj = val;
  if (!val) {
    obj = '无';
  }
  return obj;
};
// 可用角色列表启用状态
function lockStatusToText(val) {
  let obj = {
    1: '启用',
    2: '禁用'
  };
  return obj[val];
}
// 男女
function sexfiter(val) {
  let obj = {
    1: '男',
    2: '女'
  };
  return obj[val];
}
// 角色状态
function roleIdToText(val) {
  let obj = {
    1: '启用',
    2: '冻结'
  };
  return obj[val];
}

// 冻结状态
function venFreezeStatusfiter(val) {
  let obj = {
    1: '未冻结',
    2: '已冻结'
  };
  return obj[val];
}
// 支付方式
function payTypefiter(val) {
  let obj = {
    1: '在线支付',
    2: '货到付款',
    3: '在线支付    货到付款'
  };
  return obj[val];
}
// 支付类型（订单中心）
function payTypeOrderfiter(val) {
  let obj = {
    1: '货到付款',
    2: '到店自提',
    3: '银行汇款',
    4: '在线支付'
  };
  return obj[val];
}
// 商户性质
function venTypefiter(val) {
  let obj = {
    1: '自营',
    2: '三方'
  };
  if (!val || val === null || null === '') {
    return '无';
  } else {
    return obj[val];
  }
}
// 审核状态
function venSatatusfiter(val) {
  let obj = {
    1: '待审核',
    2: '已审核',
    3: '驳回',
    4: '已签订'
  };
  return obj[val];
}
// 企业类型
function comTypefiter(val) {
  let obj = {
    1: '企业类型',
    3: '生产加工厂',
    4: '代理商',
    5: '品牌商',
    6: '经销商',
    7: '进出口贸易',
    8: '协会合作社'
  };
  return obj[val];
}
// 企业性质
function venPropertiesfiter(val) {
  let obj = {
    1: '公司企业',
    3: '个体工商户',
    4: '个人',
    9: '其他性质'
  };
  return obj[val];
}
// 主营类型
function businessTypefiter(val) {
  let obj = {
    1: '肉禽蛋类',
    2: '海鲜水产',
    3: '水果蔬菜',
    4: '干调类',
    5: '蔬菜类',
    6: '粮油副食',
    7: '酒水饮品',
    8: '酒店用品',
    9: '进口食品'
  };
  return obj[val];
}
// 资质标识
function apFlagfiter(val) {
  let obj = {
    1: '组织机构代码证号码',
    2: '税务登记证号码',
    3: '身份证',
    4: '动物防疫条件合格证',
    5: '食品生产许可证',
    6: '身份证授权书',
    7: '食品流通许可证',
    8: '授权书',
    9: '生猪定点屠宰证',
    10: '捕捞许可证',
    11: '养殖证明',
    12: '产品产地证明',
    13: '酒类流通备案登记证',
    14: '进口货物报关单',
    15: '出入境检验检疫合格证明',
    16: '动植物检验检疫证',
    17: '原产地证明',
    18: '无公害产品证书',
    19: '一般纳税人',
    20: '小额纳税人资质',
    21: '其他证明',
    22: '营业执照号码'
  };
  return obj[val];
}
// 商品是否上架
function upFlagfiter(val) {
  let obj = {
    1: '上架',
    2: '下架',
    3: '强制下架'
  };
  return obj[val];
}
// 是否冻品
function frozenFlagfiter(val) {
  let obj = {
    1: '是',
    2: '否'
  };
  return obj[val];
}
// 采购业务状态
function frozenFlagtypeofiter(val) {
  let obj = {
    1: '冻品',
    2: '鲜品',
    3: '冻鲜品'
  };
  return obj[val];
}
// 定价方式
function priceMethodfiter(val) {
  let obj = {
    1: '询报价',
    2: '一口价',
    3: '面议'
  };
  return obj[val];
}
// 售卖方式
function sellTypefiter(val) {
  let obj = {
    1: '散装',
    2: '包装'
  };
  return obj[val];
}
// 计价方式
function pricingTypefiter(val) {
  let obj = {
    1: '重量',
    2: '数量'
  };
  return obj[val];
}
// 用户类型 --
function userTypefiter(val) {
  let obj = {
    1: '采购商',
    2: '供应商'
  };
  return obj[val];
}
// 验证状态
function verifyFlagfiter(val) {
  let obj = {
    1: '待审核',
    2: '审核通过',
    3: '审核不通过'
  };
  return obj[val];
}
// 审核状态
function verifyFlagmerberfiter(val) {
  let obj = {
    1: '待提交',
    2: '待审核',
    3: '已审核',
    4: '已驳回'
  };
  return obj[val];
}
// 注册来源
function regSourcefiter(val) {
  let obj = {
    1: 'Android',
    2: 'iPhone',
    3: '微信',
    4: '邀请链接',
    5: '地推活动',
    6: 'PC',
    7: '销售app',
    8: '转介绍',
    9: '后台添加'
  };
  return obj[val];
}
// 活动类型
function disTypefilter(val) {
  let obj = {
    1: '优惠券',
    2: '限时抢购',
    3: '其他',
    4: '预售'
  };
  return obj[val];
}
// 发放方式
function sendTypefilter(val) {
  let obj = {
    1: '买家领取',
    2: '指定条件发放',
    3: '指定用户发放'
  };
  return obj[val];
}
// 发放状态
function sendStatusfilter(val) {
  let obj = {
    1: '待发放',
    2: '发放中',
    3: '已发完',
    4: '已结束'
  };
  return obj[val];
}
// 使用状态
function useStatusfilter(val) {
  let obj = {
    1: '已使用',
    2: '未使用',
    3: '已过期'
  };
  return obj[val];
}
// 使用平台
function usePlatfilter(val) {
  let obj = {
    1: '全平台',
    2: '移动专享'
  };
  return obj[val];
}
// 使用范围
function useRangefilter(val) {
  let obj = {
    1: '全部商品',
    2: '指定品类',
    3: '指定商品'
  };
  return obj[val];
}
// 有效时间类型
function useTimeTypefilter(val) {
  let obj = {
    1: '固定时段',
    2: '固定天数'
  };
  return obj[val];
}
// 发送状态
function smsSendStatusfilter(val) {
  let obj = {
    1: '发送成功',
    2: '发送失败'
  };
  return obj[val];
}
// 会员状态
function freezeStatusfilter(val) {
  let obj = {
    1: '正常',
    2: '冻结'
  };
  return obj[val];
}
// 展示终端
function pagePlatfilter(val) {
  let obj = {
    1: 'pc端',
    2: '移动端'
  };
  return obj[val];
}
// 类型状态
function userTypeStatusfilter(val) {
  let obj = {
    1: '开启',
    2: '关闭'
  };
  return obj[val];
}
// 适用对象
function smsSendObjfilter(val) {
  let obj = {
    1: '鲜易商城用户',
    2: '鲜易云ERP用户',
    3: '销销乐用户'
  };
  return obj[val];
}
// 适用对象
function numTypefilter(val) {
  let obj = {
    1: '不限制',
    2: '限制'
  };
  return obj[val];
}
// 使用状态
function smsStatusfilter(val) {
  let obj = {
    1: '使用中',
    2: '已禁用'
  };
  return obj[val];
}
// 联系人类型
function contactTypefilter(val) {
  let obj = {
    1: '店铺负责人',
    2: '运营联系人',
    3: '售后联系人',
    4: '财务联系人'
  };
  return obj[val];
}
// 配送方式
function shipTypefilter(val) {
  let obj = {
    1: '配送',
    2: '委托自提',
    3: '到店自提'
  };
  return obj[val];
}
// 是否指定车辆
function appointCarFlagfilter(val) {
  let obj = {
    1: '可指定车辆',
    2: '不可指定车辆'
  };
  return obj[val];
}
// 状态
function enabledStatusfilter(val) {
  let obj = {
    1: '启用',
    2: '禁用'
  };
  return obj[val];
}
// 取货时间段 1上午 2下午
function pickingSpanfilter(val) {
  let obj = {
    1: '上午',
    2: '下午'
  };
  return obj[val];
}
// 取货天 1明天2后天
function pickingDayfilter(val) {
  let obj = {
    1: '明天',
    2: '后天'
  };
  return obj[val];
}
//  消息类型：1文字消息2图片类型
function autoKeywordTypefilter(val) {
  let obj = {
    1: '文字消息',
    2: '图片类型'
  };
  return obj[val];
}
// 内容类型
function contentTypefilter(val) {
  let obj = {
    1: '商品',
    2: '分类',
    3: '商户',
    4: '链接',
    5: '频道页',
    6: '底部icon'
  };
  return obj[val];
}
// 版本名称
function appNameIdfilter(val) {
  let obj = {
    1: '鲜易商城',
    2: '消消乐'
  };
  return obj[val];
}
// 终端系统
function sysTypefilter(val) {
  let obj = {
    1: 'Android',
    2: 'ios'
  };
  return obj[val];
}
// 是否强制更新
function forceUpdateFlagfilter(val) {
  let obj = {
    1: '是',
    2: '否'
  };
  return obj[val];
}
// 版本名称
function statusfilter(val) {
  let obj = {
    1: '启用',
    2: '禁用'
  };
  return obj[val];
}
// 版本名称
function replyFlagfilter(val){
  let obj = {
    1: '未回复',
    2: '已回复'
  };
  return obj[val];
}
// 版本名称
function sourcefilter(val) {
  let obj = {
    1: 'pc',
    2: '安卓',
    3: 'ios',
    4: '微信商城'
  };
  return obj[val];
}
function priceToText(val) {
  // 钱保留2位数字
  if (!val) {
    return 0;
  } else {
    return parseFloat(val).toFixed(2);
  }
};
// 订单状态
function orderStatusfilter(val) {
  let obj = {
    1: '已提交',
    2: '待支付',
    3: '支付中',
    4:'支付失败',
    5:'待发货',
    6:'已发货',
    7:'待审核',
    9: '取消中',
    10: '已取消',
    11: '已锁定',
    12: '已完成',
    13: '退款中',
    20:'退款退货中',
    30:'售后完成',
    40:'售后驳回',
    50: '退款失败',
    // , 11: '支付处理中'
  };
  return obj[val];
}
// 订单来源
function orderSourcefilter(val) {
  let obj = {
    1: 'android',
    2: 'ios',
    3: '微信',
    4: 'pc',
    5: '销销乐',
    6: '其它',
    7: '意向单'
  };
  return obj[val];
}
// 生成订单方式
function orderAutoFlagfilter(val) {
  let obj = {
    1: '自动',
    2: '手动'
  };
  return obj[val];
}
// 付款状态
function payStatusfilter(val) {
  let obj = {
    1: '已支付',
    2: '未支付',
    11: '处理中'
  };
  return obj[val];
}
//提现状态
function settleStateNewfilter(val){
  let obj = {
    1: '提现成功',
    2: '提现失败',
    3: '处理中',
    4: '待审核',
    5: '已审核',
    6: '未发起',
    7: '已驳回',
    8: '已作废'
  };
  return obj[val];
}
// 定价方式
function orderTypefiter(val) {
  let obj = {
    1: '一口价',
    2: '询报价'
  };
  return obj[val];
}
// 询价状态
function inquiryStatusfilter(val) {
  let obj = {
    0: '待询价',
    1: '已报价',
    2: '已失效',
    3: '询价中',
    4: '已完成',
    5: '已取消',
    6: '已过期',
    7: '已驳回'
  };
  return obj[val];
}
// 询价类型
function inquiryTypefiter(val) {
  let obj = {
    0: '自提价',
    1: '配送价'
  };
  return obj[val];
}
// 当前发起结算状态
function bkgeStatusfiter(val) {
  let obj = {
    1: '未发起结算',
    2: '结算中'
  };
  return obj[val];
}
// 佣金签订方式
function signWayfiter(val) {
  let obj = {
    1: '按订单实发金额',
    2: '按实发重量（元/吨）',
    3: '按实发数量'
  };
  return obj[val];
}
// 结算方式
function settleWayfiter(val) {
  let obj = {
    1: '按固定周期',
    2: '按固定日'
  };
  return obj[val];
}
// 结算周期单位
function periodUnitfiter(val) {
  let obj = {
    1: '天',
    2: '周',
    3: '月'
  };
  return obj[val];
}
// 佣金设置方式
function bkgeSetWayfiter(val) {
  let obj = {
    1: '按商户设置佣金',
    2: '按分类设置佣金',
    3: '按商品SKU设置佣金'
  };
  return obj[val];
}
// 结账状态
function pbStatusfiter(val) {
  let obj = {
    1: '未结账',
    2: '部分结账',
    3: '已结账'
  };
  return obj[val];
}
// 支出类型
function expenseTypefiter(val) {
  let obj = {
    1: '采购付款',
    2: '其他'
  };
  return obj[val];
}
// 复核状态
function reviewStatusfiter(val) {
  let obj = {
    1: '未复核',
    2: '已复核',
    3: '复核异常'
  };
  return obj[val];
}
// 账单确认情况
function confirmBillfiter(val) {
  let obj = {
    1: '未确认',
    2: '已确认'
  };
  return obj[val];
}
// 平台结算方式
function bkgeSettleWayfiter(val) {
  let obj = {
    1: '按固定周期',
    2: '按固定日'
  };
  return obj[val];
}
// 作废状态
function cancelStatusfiter(val) {
  let obj = {
    1: '正常',
    2: '已作废'
  };
  return obj[val];
}
// 采购货款状态
function purchPayStatusfiter(val) {
  let obj = {
    1: '未结算',
    2: '结算中',
    3: '已结算'
  };
  return obj[val];
}
// 收款状态
function sbillStatusfiter(val) {
  let obj = {
    1: '未收款',
    2: '部分收款',
    3: '已收款'
  };
  return obj[val];
}
// 收款状态
function sbillPayTypefiter(val) {
  let obj = {
    1: 'pos',
    2: '微信',
    3: '其它'
  };
  return obj[val];
}
// 发票内容
function taxContentfiter(val) {
  let obj = {
    1: '明细',
    2: '生鲜'
  };
  return obj[val];
}
// 文章状态
function cmsArticleStatusfiter(val) {
  let obj = {
    1: '已发布',
    2: '草稿'
  };
  return obj[val];
}
// 状态
function areaLevelfilter(val) {
  let obj = {
    1: '省',
    2: '市',
    3:'区'
  };
  return obj[val];
}

// 结算方式
function purchSettleWayfiter(val) {
  let obj = {
    1: '账期结算',
    2: '预付款',
    3: '现结'
  };
  return obj[val];
}
// 首页数据统计请求类型
function homepageDatafiter(val) {
  let obj = {
    userNum: '本月新增用户',
    orderNum: '本月订单数',
    dayOrderNum: '今日订单',
    dayPayNum: '今日已付款'
  };
  return obj[val];
}
// 适用对象(消息列表)
function msgSendObjfilter(val) {
  let obj = {
    1: '鲜易商城用户',
    2: '销销乐用户'
  };
  return obj[val];
}
// 消息发送类型
function msgsendTypefilter(val) {
  let obj = {
    1: '仅展示',
    2: '仅推送',
    3: '展示并推送'
  };
  return obj[val];
}
// 是否支持跳转(信息中心消息模板)
function jumpFlagfilter(val) {
  let obj = {
    1: '是',
    2: '否'
  };
  return obj[val];
}
// 适用类型(信息中心)
function msgSuitTypefilter(val) {
  let obj = {
    1: '订单通知',
    2: '优惠券通知',
    3: '客户通知',
    4: '审批通知',
    5: '求购通知',
    6: '回复通知',
    7: '意向单通知',
    8: '身份认证通知'
  };
  return obj[val];
}
// 状态(信息中心消息模板)
function msgStatusfilter(val) {
  let obj = {
    1: '使用中',
    2: '已禁用'
  };
  return obj[val];
}
// 是否读取(信息中心)
function readFlagfilter(val) {
  let obj = {
    1: '未读',
    2: '已读'
  };
  return obj[val];
}
// 启用状态（限时抢购）
function tempStatusfilter(val) {
  let obj = {
    1: '启用',
    2: '禁用',
    3: '已结束'
  };
  return obj[val];
}
// 冲销单状态
function rbStatusfilter(val) {
  let obj = {
    1: '未冲销',
    2: '冲销中',
    3: '已冲销',
    4: '已作废'
  };
  return obj[val];
}
// 预付业务
function prepayTypefilter(val) {
  let obj = {
    1: '整柜',
    2: '零采',
    3: '其他'
  };
  return obj[val];
}
// 预付状态
function prepayStatusfilter(val) {
  let obj = {
    1: '待审核',
    2: '审核不通过',
    3: '财务待审核',
    4: '财务审核不通过',
    5: '预付中',
    6: '预付完成'
  };
  return obj[val];
}
// 用户性质
function userPropertiesfiter(val) {
  let obj = {
    1: '个人',
    2: '个体工商户',
    3: '企业'
  };
  return obj[val];
}
// 用户身份验证状态
function authenticationFlagfiter(val) {
  let obj = {
    1: '待提交',
    2: '待审核',
    3: '已审核',
    4: '已驳回'
  };
  return obj[val];
}
// 意向单状态
function wishStatusfiter(val) {
  let obj = {
    1: '已完成',
    2: '已报价',
    3: '已驳回',
    4: '已过期',
    5: '撮合中',
    6: '待撮合',
    7: '已取消'
  };
  return obj[val];
}
// 采购(意向单)类型
function purchaseTypefiter(val) {
  let obj = {
    1: '整柜',
    2: '零采',
    3: '三方'
  };
  return obj[val];
}
// 数据中心
function tabcarNavfiter(val) {
  let obj = {
    0: '汇总',
    1: 'IOS',
    2: '安卓',
    3: '微信商城',
    4: '销销乐'
  };
  return obj[val];
}

// 支付类型
function dealWayfiter(val) {
  let obj = {
    2: '网银支付',
    5: '快捷支付',
    6: '扫码支付',
    8: '公众号支付',
    9: '网银支付',
    10: '扫码收款',
    11: '线下打款',
    12: '手机app跳转支付'
  };
  return obj[val];
}

function pricingTypeToText(type) {
  // 计价方式1：重量 2：数量
  let obj = {
    1: '重量',
    2: '数量'
  };
  return obj[type];
};
// 处理结果状态
function approOptToText(type) {
  // 1拒绝 2通过,0发起申请
  let obj = {
    0: '发起申请',
    1: '拒绝',
    2: '通过'
  };
  return obj[type];
};
// 支付状态：
function payStatusToText(type) {
  let obj = {
    0: '未支付',
    1: '支付成功',
    2: '支付失败',
    3: '结算处理中',
    4: '银行受理中'
  };
  return obj[type];
};
// 财务操作项显示
function checkStatusToText(checkStatus, taskStatus) {
  let txt = '';
  if (checkStatus === 1) {
    txt = '编辑';
  } else if (checkStatus === 2 && taskStatus === 2) {
    txt = '审核';
  } else if (checkStatus === 2 && taskStatus !== 2) {
    txt = '查看';
  } else {
    txt = '查看';
  }
  return txt;
}
let dataListObj = {};
for (let i in datalist) {
  dataListObj[i] = (v) => {
    let newObj = {};
    datalist[i].forEach(o => {
      newObj[o.value] = o.name;
    });
    return newObj[v];
  };
}


function disTypeToText(type) {
  // 优惠类型 1 优惠券 2 订单满减 3 订单满折 4: '预售'
  let obj = {
    1: '优惠券',
    2: '限时抢购',
    3: '订单满折',
    4: '预售'
  };
  return obj[type];
};
function navTypeFilter(type) {
  // 导航分类1首页按钮导航 2 个人中心按钮导航 3 首页轮播banner广告 4 活动区域广告图片 5 首页精品推荐轮播图
  // 6 热销榜单轮播图 7新品首发轮播图 8促销单品轮播图 9资讯轮播图
  let obj = {
    1: '首页按钮导航',
    2: '个人中心按钮导航',
    3: '首页轮播banner广告',
    4: '活动区域广告图片',
    5:'首页精品推荐轮播图',
    6:'热销榜单轮播图',
    7:'新品首发轮播图',
    8:'促销单品轮播图',
    9:'资讯轮播图',
    10:'积分商城轮播图',
    11:'第2部分',
    12:'第3部分',
    13:'第4部分',
    14:'第5部分',
    15:'第6部分',
    16:'第7部分',
    17:'第8部分',
    18:'第9部分',
    19:'第10部分',
    20:'第11部分',
    21:'第12部分',
    22:'第13部分',
    23:'第14部分',
    24:'第15部分',
    25:'第16部分',
    26:'第17部分',
  };
  return obj[type];
};
function tempStatusToText(val) {
  let obj = {
    1: '启用',
    2: '禁用',
    3: '已结束'
  };
  return obj[val];
}

// 售后来源
function afterSaleSourceToText(val) {
  // ===
  let obj = {
    1: '线上',
    2: '线下'
  };
  return obj[val];
};
// 售后类型
function afterSaleTypeToText(val) {
  // ===
  let obj = {
    1: '仅退款',
    2: '退款退货'
  };
  return obj[val];
};
// 售后原因
function afterSaleReasonToText(val) {
  // ===
  let obj = {
    1: '商品损坏',
    2: '商品错误',
    3: '无条件退款',
    4: '其他原因'
  };
  return obj[val];
};
// 售后状态
function afterSaleStatusToText(val) {
  // ===
  let obj = {
    1: '待审核',
    2: '已审核',
    3: '审核中',
    4: '已驳回',
    5: '已作废',
    6: '退款成功',
    7: '退款失败',
    8: '退款中'
  };
  return obj[val];
};

// 财务审核状态
function financeCheckStatusToText(val) {
  // ===
  let obj = {
    1: '待审核',
    2: '已审核',
    3: '已驳回'
  };
  return obj[val];
};


// 支付渠道
function payChannelToText(val) {
  // ===
  let obj = {
    1: '支付宝',
    2: '微信',
    3: '余额',
    4: '网银支付'
  };
  return obj[val];
};
// 提现渠道
function settleChannelFilter(val) {
  // ===
  let obj = {
    1: '微信',
    2: '银行卡',
    3: '支付宝'
  };
  return obj[val];
};

// 退款类型
function refundTypeToText(val) {
  let obj = {
    1: '取消订单退款',
    2: '实发差异退款',
    3: '售后退款',
    4: '售后退货退款'
  };
  return obj[val];
};

// 退款状态
function refundStatusToText(val) {
  let obj = {
    1: '待确认退款',
    2: '已确认退款',
    3: '退款失败',
    4: '退款处理中',
    5: '拒绝退款',
    7: '退款成功'
  };
  return obj[val];
};

// 付款类型 支付类型
function payTypeToText(val) {
  // ===
  let obj = {
    1: '货到付款',
    2: '到店自提',
    3: '银行汇款',
    4: '在线支付'
  };
  return obj[val];
};

// 使用状态
function yesOrNofilter(val) {
  let obj = {
    1: '是',
    2: '否'
  };
  return obj[val];
}
//交易记录交易类型 1:支付 2:提现 3:充值 4:退款 5:订单结算 6:订单取消 7:提现取消/驳回 8:订单退款  9：平台操作
function payDealType(val) {
  // ===
  let obj = {
    1: '支付',
    2: '提现',
    3: '充值',
    4: '退款',
    5: '订单结算',
    6: '订单取消',
    7: '提现取消/驳回',
    8: '订单退款',
    9: '平台操作',
    10: '佣金结算'
  };
  return obj[val];
};
// 使用状态
function userGroupOrderStatusToText(val) {
  let obj = {
    1: '未退款',
    2: '退款中',
    3: '已退款'
  };
  return obj[val];
}


function numberToFixed2(val) {
  return parseFloat(val).toFixed(2);
};
export default {
  tempStatusToText,
  disTypeToText,
  navTypeFilter,
  contactTypefilter,
  toPercent,
  moneySkin,
  bankDot,
  numberToText,
  smsStatusfilter,
  numTypefilter,
  smsSendObjfilter,
  userTypeStatusfilter,
  pagePlatfilter,
  freezeStatusfilter,
  smsSendStatusfilter,
  useTimeTypefilter,
  useRangefilter,
  usePlatfilter,
  useStatusfilter,
  sendStatusfilter,
  sendTypefilter,
  disTypefilter,
  regSourcefiter,
  verifyFlagfiter,
  userTypefiter,
  pricingTypefiter,
  sellTypefiter,
  priceMethodfiter,
  frozenFlagtypeofiter,
  frozenFlagfiter,
  upFlagfiter,
  apFlagfiter,
  businessTypefiter,
  venPropertiesfiter,
  comTypefiter,
  venSatatusfiter,
  venTypefiter,
  payTypefiter,
  venFreezeStatusfiter,
  noneToText,
  autoOperationFlagfiter,
  receivingTimePlatToText,
  feeFlagToText,
  carSourceToText,
  lockStatusToText,
  roleIdToText,
  sexfiter,
  auditFlagfiter,
  inOrOutfiter,
  millisecondFormat,
  shipTypefilter,
  appointCarFlagfilter,
  enabledStatusfilter,
  autoKeywordTypefilter,
  contentTypefilter,
  appNameIdfilter,
  sysTypefilter,
  forceUpdateFlagfilter,
  statusfilter,
  replyFlagfilter,
  sourcefilter,
  priceToText,
  orderStatusfilter,
  orderSourcefilter,
  orderAutoFlagfilter,
  payTypeOrderfiter,
  payStatusfilter,
  orderTypefiter,
  settleStateNewfilter,
  inquiryTypefiter,
  bkgeStatusfiter,
  signWayfiter,
  settleWayfiter,
  periodUnitfiter,
  bkgeSetWayfiter,
  pbStatusfiter,
  expenseTypefiter,
  reviewStatusfiter,
  confirmBillfiter,
  bkgeSettleWayfiter,
  cancelStatusfiter,
  purchPayStatusfiter,
  sbillStatusfiter,
  sbillPayTypefiter,
  taxContentfiter,
  cmsArticleStatusfiter,
  purchSettleWayfiter,
  homepageDatafiter,
  msgSendObjfilter,
  msgsendTypefilter,
  jumpFlagfilter,
  msgSuitTypefilter,
  msgStatusfilter,
  readFlagfilter,
  tempStatusfilter,
  rbStatusfilter,
  prepayTypefilter,
  prepayStatusfilter,
  userPropertiesfiter,
  authenticationFlagfiter,
  verifyFlagmerberfiter,
  wishStatusfiter,
  purchaseTypefiter,
  tabcarNavfiter,
  dealWayfiter,
  pricingTypeToText,
  approOptToText,
  payStatusToText,
  checkStatusToText,
  afterSaleSourceToText,
  afterSaleTypeToText,
  afterSaleReasonToText,
  afterSaleStatusToText,
  financeCheckStatusToText,
  payChannelToText,
  settleChannelFilter,
  refundTypeToText,
  refundStatusToText,
  payTypeToText,
  numberToFixed2,
  payDealType,
  yesOrNofilter,
  pickingSpanfilter,
  pickingDayfilter,
  userGroupOrderStatusToText,
  areaLevelfilter,
  ...dataListObj
};



// WEBPACK FOOTER //
// ./src/filters/index.js